import CalculatorPageTemplate from '@templates/CalculatorsPage';

const CalculatorsPage = () => {
  const fixtures = {
    mortgage: {
      name: 'Mortgage Calculator',
      description: 'Calculate your monthly mortgage payments.'
    },
    affordability: {
      name: 'Affordability Calculator',
      description: 'Determine how much house you can afford.'
    },
    refinance: {
      name: 'Refinance Calculator',
      description: 'See if refinancing your mortgage makes sense.'
    },
    'rent-vs-buy': {
      name: 'Rent vs. Buy Calculator',
      description: 'Compare the long-term costs of renting versus buying.'
    }
  };

  return <CalculatorPageTemplate fixtures={fixtures} />;
};

export default CalculatorsPage;
